import dayjs from 'dayjs';
import { ISO8601 } from '../support/ISO8601';

export const initCap = (s: string) => s[0].toUpperCase() + s.substring(1);

export const formatAge = (dob?: string) => {
    if (!dob) {
        return '';
    }

    const today = dayjs();
    const dayjsDob = dayjs(dob);
    const years = today.diff(dayjsDob, 'years');

    const count = (years ? years : today.diff(dayjsDob, 'months'));
    const units = (years ? 'yr' : 'mo') + (count !== 1 ? 's' : '');

    return `${count} ${units} old`;
};

export const formatRelativeTime = (dateTime?: ISO8601) => {
    if (dateTime) {
        const now = dayjs();
        const date = dayjs(dateTime);
        const diff = now.diff(date, 'days');
        return diff < 7 ? dayjs().to(date) : date.format('dddd, MMMM Do');
    }
};

export const round = (value: number, dp: number): number => {
    const divisor = 10 ** dp;
    return Math.round(value * divisor) / divisor;
};

// includes extension if it exists
export const formatPhoneNumber = (phone: string): string => {
    return phone.replace(/(\d{3})(\d{3})(\d{4})( x\d+)?/, '$1-$2-$3 $4');
};

export const formatDuration = (minutes: number): string => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;

    if (hours > 0 && mins > 0) {
        return `${hours}hr ${mins}min`;
    } else if (hours > 0) {
        return `${hours}hr`;
    } else {
        return `${mins}min`;
    }
};
